import {Yii} from "libraries/interfaces/Yii";

const FORM_LABELS = {
    cc: Yii.t('wui-sasha-js', 'CC :'),
    bcc: Yii.t('wui-sasha-js', 'BCC :'),
    subject: Yii.t('wui-sasha-js', 'Objet :'),
    body: Yii.t('wui-sasha-js', 'Message :'),
    replyTo: Yii.t('wui-sasha-js', 'Répondre à :')
};

const CARD_LABELS = {
    header: Yii.t('wui-sasha-js', "Saisir l'email"),
    goBack: Yii.t('wui-sasha-js', 'Retour'),
    previousStep: Yii.t('wui-sasha-js', 'Retour au choix du modèle'),
    nextStep: Yii.t('wui-sasha-js', 'Prévisualiser les emails'),
};

const LOADER_LABELS = {
    emailTemplateLoading: Yii.t('wui-sasha-js', 'Chargement des modèles en cours')
};

export const WORDING = {
    ...CARD_LABELS,
    ...FORM_LABELS,
    ...LOADER_LABELS
};